import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import {
    Block,
    Button,
    ButtonContainer,
    Title,
    Image,
    Row,
} from 'yurstrap';

import ModalLink from '../../components/ModalLink';

import Routes from '../constants/Routes';
import { getScopeSelector } from '../../commons/reduxModules/Authentication';
import Scopes from '../../constants/Scopes';

import illuMailSupport from '../../../../images/support/illu__mail--support.svg';
import illuMailSales from '../../../../images/support/illu__mail--sales.svg';

const propTypes = {
    scope: PropTypes.string.isRequired,
};

const defaultProps = {};

class HomePage extends Component {

    constructor(props) {
        super(props);
        this.renderContactSupportButton = this.renderContactSupportButton.bind(this);
        this.renderContactSalesmanButton = this.renderContactSalesmanButton.bind(this);
        this.renderContactSalesman = this.renderContactSalesman.bind(this);
        this.renderContactSupport = this.renderContactSupport.bind(this);
    }

    renderContactSupportButton() {
        const { scope } = this.props;
        const linkProps = {
            componentClass: Link,
        };
        if (Scopes.USER !== scope) {
            linkProps.componentClass = ModalLink;
            linkProps.modalName = 'support';
        }
        return [
            <Button
                key="desktop"
                color="primary"
                expand
                className="u-display__none--s u-display__none--m mr-0"
                to={Routes.FAQ_PAGE.link}
                /* eslint-disable-next-line react/jsx-props-no-spreading */
                {...linkProps}
            >
                Trouver de l'aide
            </Button>,
            <Button
                key="mobile"
                color="primary"
                expand
                className="u-display__none u-display__b--s u-display__b--m"
                to={Routes.SUPPORT_ROOT.link}
                /* eslint-disable-next-line react/jsx-props-no-spreading */
                {...linkProps}
            >
                Trouver de l'aide
            </Button>,
        ];
    }

    renderContactSupport() {
        return (
            <div key="contactSupport" className="u-col--m-6 u-col--s-12 mb-4 px-2" style={{ maxWidth: '380px' }}>
                <Block className="p-5 pb-6">
                    <Image
                        alt="Support portrait illustration"
                        className="mb-3 mx-a"
                        size="m"
                        src={illuMailSupport}
                    />
                    <Title>
                        Support
                    </Title>
                    <p className="u-font-size--3 u-color__grey--60 mb-4">
                        Un problème ? Les solutions se trouvent ici !
                    </p>
                    <ButtonContainer>
                        {this.renderContactSupportButton()}
                    </ButtonContainer>
                </Block>
            </div>
        );
    }

    renderContactSalesmanButton() {
        const { scope } = this.props;
        const linkProps = {
            componentClass: Link,
        };
        if (Scopes.USER !== scope) {
            linkProps.componentClass = ModalLink;
            linkProps.modalName = 'support';
        }
        return (
            <Button
                color="premium"
                className="c-btn--premium"
                expand
                to={Routes.CONTACT_SALESMAN.link}
                /* eslint-disable-next-line react/jsx-props-no-spreading */
                {...linkProps}
            >
                Contacter un commercial
            </Button>
        );
    }

    renderContactSalesman() {
        return (
            <div key="contactSalesman" className="u-col--m-6 u-col--s-12 mb--m-4 px-2" style={{ maxWidth: '380px' }}>
                <Block className="p-5 pb-6">
                    <Image
                        alt="Sales portrait illustration"
                        className="mb-3 mx-a"
                        size="m"
                        src={illuMailSales}
                    />
                    <Title>
                        Commercial
                    </Title>
                    <p className="u-font-size--3 u-color__grey--60 mb-4">
                        Un projet ? Notre équipe est là pour vous conseiller !
                    </p>
                    <ButtonContainer>
                        {this.renderContactSalesmanButton()}
                    </ButtonContainer>
                </Block>
            </div>
        );
    }

    render() {
        const { scope } = this.props;
        const contactBlock = [];
        if (Scopes.USER === scope) {
            contactBlock.push(this.renderContactSalesman(), this.renderContactSupport());
        } else {
            contactBlock.push(this.renderContactSupport(), this.renderContactSalesman());
        }
        return (
            <>
                <div className="p-5 px--s-3 u-text-align__center u-bg__grey--20 " style={{ minHeight: '600px', boxShadow: 'inset 0px 300px 0px 0px #2d3f71' }}>
                    <Title componentClass="h1" className="my-4 u-color__white">
                        Contacter un expert Yurplan
                    </Title>
                    <Row hcenter>
                        {contactBlock}
                    </Row>
                </div>
            </>
        );
    }

}

HomePage.propTypes = propTypes;
HomePage.defaultProps = defaultProps;

function mapStateToProps(state) {
    return {
        scope: getScopeSelector(state),
    };
}

export default connect(
    mapStateToProps,
)(HomePage);
